import { AfterViewInit, Directive, ElementRef, Host, Input, Renderer2 } from '@angular/core';
import * as Bootstrap from 'bootstrap';

@Directive({
    selector: '[pxTooltip]',
})
export class PxTooltipDirective implements AfterViewInit {
    @Input() pxTooltip: 'info' | 'help' = 'info';
    @Input() title = '';
    @Input() content = '';
    @Input() size: 'small' | 'big' = 'big';
    @Input() html = false;
    @Input() trigger: 'click' | 'hover' | 'focus';
    @Input() delay = '500';

    @Input() placement: 'top' | 'right' | 'bottom' | 'left' = 'top';

    constructor(@Host() private el: ElementRef, private renderer: Renderer2) {}

    ngAfterViewInit() {
        this.renderer.addClass(this.el.nativeElement, 'ba-round-icon-btn');
        this.renderer.addClass(
            this.el.nativeElement,
            this.pxTooltip === 'help' ? 'ba-icon-help' : 'ba-icon-information'
        );
        this.renderer.setAttribute(this.el.nativeElement, 'aria-label', 'Tooltip anzeigen zum Thema ' + this.title);
        this.renderer.setAttribute(
            this.el.nativeElement,
            'data-bs-toggle',
            this.size === 'big' ? 'popover' : 'tooltip'
        );
        if (this.size === 'big') {
            this.renderer.setAttribute(this.el.nativeElement, 'data-bs-content', this.content);
        }

        this.renderer.setAttribute(this.el.nativeElement, 'type', 'button');
        this.renderer.setAttribute(this.el.nativeElement, 'data-bs-original-title', this.title);
        this.renderer.setAttribute(this.el.nativeElement, 'data-bs-html', `${this.html}`);
        this.renderer.setAttribute(this.el.nativeElement, 'data-bs-placement', this.placement);
        this.renderer.setAttribute(this.el.nativeElement, 'data-bs-delay', this.delay);

        this.renderer.setStyle(this.el.nativeElement, 'padding-top', '2px');

        if (this.trigger) {
            this.renderer.setAttribute(this.el.nativeElement, 'data-bs-trigger', this.trigger);
        }

        if (this.size === 'small') {
            const Tooltip = new Bootstrap.Tooltip(this.el.nativeElement);
        } else {
            const Popover = new Bootstrap.Popover(this.el.nativeElement);
        }

        const buttonEl = this.el.nativeElement as HTMLButtonElement;
        if (buttonEl?.parentElement?.nodeName === 'LABEL') {
            this.renderer.addClass(this.el.nativeElement, 'ba-compact');
        }
    }
}
